<template>
  <!-- Optional, so it closes step 1 after the required company/brokerage fields.
       Shown without a website too: the fields simply stay empty then. -->
  <div data-testid="onboarding-legal-urls">
    <v-divider class="my-6" />
    <h3 class="text-subtitle-1 font-weight-bold mb-1">
      {{ $t('onboarding.wizard.review.legal-urls-title') }}
    </h3>
    <p class="text-body-2 text-medium-emphasis mb-4">
      {{ $t('onboarding.wizard.review.legal-urls-hint') }}
    </p>

    <OnboardingFormField
      class="mb-4"
      field-key="linkImprint"
      icon="mdi-scale-balance"
      :label="$t('onboarding.company-data.web.imprint')"
    >
      <v-text-field
        :model-value="formData.linkImprint"
        id="onboarding-field-linkImprint"
        data-ai-field="linkImprint"
        :class="fieldClass('linkImprint')"
        variant="outlined"
        density="comfortable"
        rounded="lg"
        :placeholder="$t('onboarding.company-data.web.imprintPlaceholder')"
        hide-details
        @focus="onFieldFocus('linkImprint')"
        @update:model-value="updateField('linkImprint', $event)"
      />
    </OnboardingFormField>

    <OnboardingFormField
      class="mb-4"
      field-key="linkPrivacy"
      icon="mdi-shield-account-outline"
      :label="$t('onboarding.company-data.web.privacy')"
    >
      <v-text-field
        :model-value="formData.linkPrivacy"
        id="onboarding-field-linkPrivacy"
        data-ai-field="linkPrivacy"
        :class="fieldClass('linkPrivacy')"
        variant="outlined"
        density="comfortable"
        rounded="lg"
        :placeholder="$t('onboarding.company-data.web.privacyPlaceholder')"
        hide-details
        @focus="onFieldFocus('linkPrivacy')"
        @update:model-value="updateField('linkPrivacy', $event)"
      />
    </OnboardingFormField>

    <OnboardingFormField
      field-key="linkAbout"
      icon="mdi-account-group-outline"
      :label="$t('onboarding.company-data.web.about')"
    >
      <v-text-field
        :model-value="formData.linkAbout"
        id="onboarding-field-linkAbout"
        data-ai-field="linkAbout"
        :class="fieldClass('linkAbout')"
        variant="outlined"
        density="comfortable"
        rounded="lg"
        :placeholder="$t('onboarding.company-data.web.aboutPlaceholder')"
        hide-details
        @focus="onFieldFocus('linkAbout')"
        @update:model-value="updateField('linkAbout', $event)"
      />
    </OnboardingFormField>
  </div>
</template>

<script setup lang="ts">
import { useOnboardingDataEntryContext } from '../../composables/onboardingDataEntryContext'
import OnboardingFormField from './OnboardingFormField.vue'

const { formData, updateField, fieldClass, onFieldFocus } = useOnboardingDataEntryContext()
</script>
